import { usePaystackPayment } from 'react-paystack';
import { getFirestore, doc, setDoc, arrayUnion } from 'firebase/firestore';
import { increment, updateDoc } from 'firebase/firestore'; // Import increment from firestore

const db = getFirestore();

const usePaystackCartPayment = ({ email, cartItems,userId, onSuccess, onClose }) => {
    

      const calculateTotalAmount = () => {
        return cartItems.reduce((total, item) => {
          // Remove currency symbol and commas, then convert to a number
          const price = parseFloat(item.price.toString().replace(/₦|,/g, '').trim());
          return total + (isNaN(price) ? 0 : price); // Add to total, ensuring it's a number
        }, 0);
      };
    
      const amount = calculateTotalAmount();
     


  const initializeCartPayment = usePaystackPayment({
    email,
    amount: amount * 100, // Paystack expects kobo
    currency: 'NGN',
    publicKey: 'pk_live_9c10c0a334dc47d2936c17caeb23425f60c08456',
  });


   // Function to save the purchase history in Firestore
   const savePurchaseHistory = async () => {
    const purchaseDetails = {
      date: new Date().toISOString(),
      totalAmount: amount,
      items: cartItems.map(item => ({
        assetId: item.id,
        name: item.name,
        downloadUrl: item.asset, // Ensure this URL is available
        thumbnail: item.thumbnail,
      })),
    };

    const userRef = doc(db, 'users', userId);

    try {
      await setDoc(userRef, {
        purchaseHistory: arrayUnion(purchaseDetails),
      }, { merge: true });
      console.log('Purchase history saved successfully!');

    // 🔼 Increment download count for each item purchased
    const incrementDownloadCount = async (assetId) => {
        const assetRef = doc(db, 'assets', assetId); // Adjust collection name
        await updateDoc(assetRef, {
          downloads: increment(1),
        });
      };
    
      // If purchaseDetails is a single item
      if (purchaseDetails.assetId) {
        await incrementDownloadCount(purchaseDetails.assetId);
      }
    
      // If purchaseDetails is an array of items (like cart)
      if (Array.isArray(purchaseDetails)) {
        for (const item of purchaseDetails) {
          if (item.assetId) {
            await incrementDownloadCount(item.assetId);
          }
        }
      }
    
    } catch (error) {
      console.error('Error saving purchase history:', error);
    }
  };

  const handleCartPayment = () => {
    if (!email || amount <= 0) {
      return alert("Invalid email or cart is empty");
    }
  
    try {
        initializeCartPayment({
          onSuccess: (ref) => {
            console.log("✅ Payment Success Ref:", ref);
            savePurchaseHistory(); // Save purchase history on successful payment
            if (onSuccess) onSuccess(); 
            onSuccess(ref);
          },
          onClose: () => {
            console.log("❌ Payment modal closed.");
            onClose();
          },
        });
      } catch (error) {
        console.error("💥 Paystack init error:", error);
        alert(`Payment failed: ${error?.message || error}`);
    }
  };
  

  return {
    handleCartPayment,
    totalAmount: amount,
  };
};

export default usePaystackCartPayment;
